import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
// import DialogTitle from '@mui/material/DialogTitle';
// import InputLabel from '@mui/material/InputLabel';
// import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
// import MenuList from '@mui/material/MenuList';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import Input from '@mui/material/Input';
// import { Balance } from '@mui/icons-material';

import "../Css/DialogSelect.css"


export default function DialogSelect(props) {
  const { uid, index, arrAll, arrSelected, positionL, 
    setAfterSelect, listVals } = props


  const [open, setOpen] = React.useState(false);
  const [posL, setPositionL] = React.useState(0);
  const [freeSearch, setSearch] = React.useState('');
   const [newArrSelected, setNewArrSelected] = React.useState(listVals);
  // const [newArrSelected, setSelected] = React.useState(arrSelected);
  // const [age, setAge] = React.useState<number | string>('');

  // const handleChange = (event: SelectChangeEvent<typeof age>) => {
  //   setAge(Number(event.target.value) || '');
  // };

 
    
 



  const handleClickOpen = (event) => {
     
    debugger;
    setNewArrSelected(listVals);
    setPositionL(event.clientX-250);
    setOpen(true);
   
  };

  const handleClose = (SelectChangeEvent) => {
    debugger;
    // if (reason !== 'backdropClick') {
      setOpen(false);
      setSearch('');
      // setAfterSelect( uid, newArrSelected);
    // }
  };

  const handleClear = (SelectChangeEvent) => {

      setSearch('');
      setNewArrSelected(arrAll);  
      setAfterSelect( index, []);
  };

    const handleCheckAll = (SelectChangeEvent) => {

      setSearch('');
      setNewArrSelected(arrAll);  
      setAfterSelect( index, arrAll);
  };


  // function FillCombo(res, id) {
  //   var tempMap = [];
  //   var mapCol = res.map(item => {
  //     if (!tempMap.includes(item[id])) {
  //       tempMap.push(item[id]);
  //       return { value: item[id] };
  //     }
  //   });
    
  //   tempMap.sort();
  //   tempMap.unshift("הכל");
  //   return tempMap;
  // }

  // const handleSearchInCol = (freeSrch, allSelected) => {
 
  //   var afterFilterData = [];

     
 
  //     if (orginalData.length === 0)
  //       setDataBefFilter(data);//לבדוק למה מגיע לכאן בלי נתונים
 
  //       afterFilterData = orginalData;       
  //        if(allSelected.lstbld.length > 0)
  //           afterFilterData = afterFilterData.filter((filter) => (allSelected.lstbld.find(val => val === filter["bld"]) 
  //                                                                     || (allSelected.lstbld.includes("") && filter["bld"].length == 0 )));  
  //       if(allSelected.lstapp.length > 0)
  //          afterFilterData = afterFilterData.filter((filter) => allSelected.lstapp.find(val => val === filter["app"])
  //                                                                     || (allSelected.lstapp.includes("") && filter["app"].length == 0 ));       
  //       if(allSelected.lstflr.length > 0)
  //          afterFilterData = afterFilterData.filter((filter) => allSelected.lstflr.find(val => val === filter["flr"])
  //                                                                     || (allSelected.lstflr.includes("") && filter["flr"].length == 0 ));       
  //       if(allSelected.lststt.length > 0)
  //          afterFilterData = afterFilterData.filter((filter) => allSelected.lststt.find(val => val === filter["stt"])
  //                                                                     || (allSelected.lststt.includes("") && filter["stt"].length == 0 ));          
  //       if(allSelected.lstupgrdStt.length > 0)
  //          afterFilterData = afterFilterData.filter((filter) => allSelected.lstupgrdStt.find(val => val === filter["upgrdStt"])
  //                                                                     || (allSelected.lstupgrdStt.includes("") && filter["upgrdStt"].length == 0 ));                
  //       if(allSelected.lstaliasName.length > 0)
  //          afterFilterData = afterFilterData.filter((filter) => allSelected.lstaliasName.find(val => val === filter["aliasName"])
  //                                                                     || (allSelected.lstaliasName.includes("") && filter["aliasName"].length == 0 ));  
  //       if(allSelected.lstqutNum.length > 0)
  //          afterFilterData = afterFilterData.filter((filter) => allSelected.lstqutNum.find(val => val === filter["qutNum"])
  //                                                                     || (allSelected.lstqutNum.includes("") && filter["qutNum"].length == 0 ));   
  //     if(allSelected.lstroom.length > 0)
  //         afterFilterData = afterFilterData.filter((filter) => allSelected.lstroom.find(val => val === filter["room"])
  //                                                                     || (allSelected.lstroom.includes("") && filter["room"].length == 0 ));   

  //     if(allSelected.lstitem.length > 0)
  //     afterFilterData = afterFilterData.filter((filter) => allSelected.lstitem.find(val => val === filter["item"])
  //     || (allSelected.lstitem.includes("") && filter["item"].length == 0 ));   

  //     if(allSelected.lstdscrpt.length > 0)
  //     afterFilterData = afterFilterData.filter((filter) => allSelected.lstdscrpt.find(val => val === filter["dscrpt"])
  //     || (allSelected.lstdscrpt.includes("") && filter["dscrpt"].length == 0 ));   

  //     if(allSelected.lstgnrlDscrpt.length > 0)
  //     afterFilterData = afterFilterData.filter((filter) => allSelected.lstgnrlDscrpt.find(val => val === filter["gnrlDscrpt"])
  //     || (allSelected.lstgnrlDscrpt.includes("") && filter["gnrlDscrpt"].length == 0 ));   

  //     if(allSelected.lstbatch.length > 0)
  //     afterFilterData = afterFilterData.filter((filter) => allSelected.lstbatch.find(val => val === filter["batch"])
  //     || (allSelected.lstbatch.includes("") && filter["batch"].length == 0 )); 

  //     if(allSelected.lstshipDate.length > 0)
  //     afterFilterData = afterFilterData.filter((filter) => allSelected.lstshipDate.find(val => val === filter["shipDate"])
  //     || (allSelected.lstshipDate.includes("") && filter["shipDate"].length == 0 ));  

  //     if(allSelected.lstinvDoc.length > 0)
  //     afterFilterData = afterFilterData.filter((filter) => allSelected.lstinvDoc.find(val => val === filter["invDoc"])
  //                                                 || (allSelected.lstinvDoc.includes("") && filter["invDoc"].length == 0 ));   
        
  //     if(allSelected.lstunitMsr.length > 0)
  //     afterFilterData = afterFilterData.filter((filter) => allSelected.lstunitMsr.find(val => val === filter["unitMsr"])
  //                                                 || (allSelected.lstunitMsr.includes("") && filter["unitMsr"].length == 0 ));   
             
  //     setDataR(afterFilterData) 
  //   if(freeSrch.length > 0 )
  //      afterFilterData = afterFilterData.includes(freeSrch);

  //   if (afterFilterData.length > 0) {
  //     let copySumTotal = { qty: 0, dlvQty: 0, openQty: 0, total: 0 }
  //     afterFilterData.map((item) => {
  //       copySumTotal.qty += Number(item.qty.replace(/,/g, ''))
  //       copySumTotal.dlvQty += Number(item.dlvQty.replace(/,/g, ''))
  //       copySumTotal.openQty += Number(item.openQty.replace(/,/g, ''))
  //       copySumTotal.total += Number(item.total.replace(/,/g, ''))
  //     })
  //     setSumTotal(copySumTotal);
  //   }
  //   setCount(afterFilterData.length);
  //   setPage(0);

  // };


  // const [personName, setPersonName] = React.useState([]);
  // const handleChange = (event: SelectChangeEvent<typeof personName>) => {
    //, typeFilter
  const handleChange = (value, e) =>{
    debugger;
    var arrSelectedNew = arrSelected;

    if(value != "הכל")
    {
      // if(typeFilter == "fromDate")
      // {
      //   arrSelectedNew = arrAll.filter(a => new Date(a) >= new Date(value));     
      // }
      // else if(typeFilter == "endDate")
      // {
      //   arrSelectedNew = arrAll.filter(a => new Date(a) <= new Date(value));     
      // }
      // else{
      if(e.target.checked)
        arrSelectedNew.push(value);
      else
        arrSelectedNew = arrSelectedNew.filter(a => a !== value );        
      // }
    }
    else 
    {
      arrSelectedNew = e.target.checked ? arrAll : [];   
        setNewArrSelected(arrAll);  
    }

    //setNewArrSelected(arrSelectedNew);
     setAfterSelect( index, arrSelectedNew );
  };


  return (
    <div>
      <Select className='multi-select' onOpen={handleClickOpen} open={false} sx={{height: 30, background:arrSelected.length > 0 && arrSelected.length != arrAll.length ? 'lightgray' : 'wite' }} 
           label="" ></Select>
      <Dialog disableEscapeKeyDown open={open} onClose={handleClose}  
        PaperProps={{ sx: { position: "fixed", top: '12%', left: posL, m: 0, maxWidth: 300} }}> 
        {/* <DialogTitle>Fill the form</DialogTitle> */}
        <DialogContent>
          <Box component="form" sx={{ display: 'flex', flexWrap: 'wrap'}}>
            {/* <FormControl sx={{ m: 1, minWidth: 120 }}>
              <InputLabel htmlFor="demo-dialog-native">Age</InputLabel>
              <Select
                native
                value={age}
                onChange={handleChange}
                input={<OutlinedInput label="Age" id="demo-dialog-native" />}
              >
                <option aria-label="None" value="" />
                <option value={10}>Ten</option>
                <option value={20}>Twenty</option>
                <option value={30}>Thirty</option>
              </Select>
            </FormControl> */}
            <FormControl sx={{ m: 1, minWidth: 120, maxHeight: 500 , direction: 'rtl' }}>
           
         
            <Input  
             placeholder="חיפוש חופשי..."
             value={freeSearch}
             onChange={(e) => setSearch(e.target.value)}
             ></Input> 
             
            {/* <MenuList> */}
                  { newArrSelected != null && newArrSelected.filter(name => name.includes(freeSearch)).map((name) => (
              <MenuItem key={name} value={name}>
                <Checkbox checked = {arrSelected.indexOf(name) > -1} onChange={(event) => handleChange(name, event)}/>
                <ListItemText primary={name} />
              </MenuItem>
            ))}
                
          {/* </MenuList> */}


              {/* </Select> */}
            </FormControl>
          </Box>
        </DialogContent>
        <DialogActions>
        <Button onClick={handleCheckAll}>בחר הכל</Button>
          <Button onClick={handleClear}>נקה בחירה</Button>
          <Button onClick={handleClose}>בחר</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}


  {/* {uid == "shipDate" ?
           
           <div style={{ display: "flex"}}> <label >
           חיפוש מתאריך:
           <input 
             type="date" pattern="dd/MM/yy" placeholder="dd/mm/yy"
             onChange={(event) => handleChange(event.target.value, event, "fromDate")}
           />
         </label>
         <label>
           עד תאריך:
           <input 
             type="date" pattern="dd/MM/yy" placeholder="dd/mm/yy" 
             onChange={(event) => handleChange(event.target.value, event, "endDate")}
           />
         </label></div>  
           : */}
